import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
	DEFAULT_AUTO_SAVE_MODE,
	migratePersistedEditorSettings,
	type AutoSaveMode,
} from "./editor-settings-state";

interface EditorSettingsState {
	autoSaveMode: AutoSaveMode;
	setAutoSaveMode: (mode: AutoSaveMode) => void;
}

// zustand の persist は version が一致する場合 migrate を呼ばず永続化データをそのまま merge に
// 渡すため、検証は migrate ではなく常に呼ばれる merge 側で行う。
export function mergeEditorSettings(
	persistedState: unknown,
	currentState: EditorSettingsState,
): EditorSettingsState {
	return { ...currentState, ...migratePersistedEditorSettings(persistedState) };
}

export const useEditorSettingsStore = create<EditorSettingsState>()(
	persist(
		(set) => ({
			autoSaveMode: DEFAULT_AUTO_SAVE_MODE,
			setAutoSaveMode: (autoSaveMode) => set({ autoSaveMode }),
		}),
		{
			name: "izanagi-editor-settings",
			version: 1,
			migrate: migratePersistedEditorSettings,
			merge: mergeEditorSettings,
			partialize: (state) => ({ autoSaveMode: state.autoSaveMode }),
		},
	),
);
